(function () {
  const chatBtn = document.getElementById("chat-with-us");
  const nextBtn = document.getElementById("go-next-step");
  const mainContainer = document.getElementById("widget-main-container");
  const guidePanel = document.getElementById("guide-panel");
  const iframeWrapper = document.getElementById("iframe-wrapper");

  const FORM_ID = "260252243614145";
  const FORM_URL = `https://form.jotform.com/${FORM_ID}`;
  let isPanelOpen = false;
  let iframeCreated = false;
  let formHandlerReady = false;

  function createIframe() {
    const iframe = document.createElement("iframe");
    iframe.id = `JotFormIFrame-${FORM_ID}`;
    iframe.title = "Order Issue Assistance Form";
    iframe.allowtransparency = "true";
    iframe.allow = "geolocation; microphone; camera; fullscreen; payment";
    iframe.src = FORM_URL;
    iframe.frameBorder = "0";
    iframe.scrolling = "auto";
    iframe.style.cssText = "width:100%;height:100%;border:none;";
    iframeWrapper.appendChild(iframe);
    iframeCreated = true;
    return iframe;
  }

  function initFormHandler(iframe) {
    if (formHandlerReady && window.jotformEmbedHandler) {
      try {
        window.jotformEmbedHandler(
          `#JotFormIFrame-${FORM_ID}`,
          "https://form.jotform.com/",
        );
      } catch (err) {
        console.error("Jotform handler error:", err);
      }
    } else {
      console.warn("Jotform handler not ready");
    }
  }

  function handleToggle() {
    if (!isPanelOpen) {
      mainContainer.style.display = "block";
      isPanelOpen = true;
    } else {
      mainContainer.style.display = "none";
      isPanelOpen = false;
      guidePanel.style.display = "block";
      iframeWrapper.style.display = "none";
    }
  }

  function handleShowForm(e) {
    if (e && !e.isTrusted && !e.detail) return;

    guidePanel.style.display = "none";
    iframeWrapper.style.display = "block";

    if (!iframeCreated) {
      const iframe = createIframe();
      initFormHandler(iframe);
    }
  }

  if (typeof jotformHandlerReady !== "undefined") {
    formHandlerReady = jotformHandlerReady;
  }

  chatBtn?.addEventListener("click", handleToggle);
  nextBtn?.addEventListener("click", handleShowForm);
})();
